import { CommonModule } from '@angular/common'
import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { DynamicTextComponent } from '../dynamic-text/dynamic-text.component'
import { ProgramTimeslotWidget } from 'htv-lib'
import { Subscription } from 'rxjs'
import { LocalChannel } from '../../interfaces/local-channel'
import { EpgService } from '../../services/epg.service'
import { LocalEPGProgram } from '../../interfaces/local-epg'
import moment from 'moment'
import { PageService } from '../../services/page.service'
import { PAGE_KEY } from '../../constants/page.constants'

@Component({
  selector: 'app-program-timeslot',
  standalone: true,
  imports: [CommonModule, DynamicTextComponent],
  templateUrl: './program-timeslot.component.html',
  styleUrls: [],
})
export class ProgramTimeslotComponent implements OnInit, OnDestroy {
  subscriptions = new Subscription()
  @Input() config!: ProgramTimeslotWidget

  locale = moment.locale()
  text = ''

  constructor(
    private epgService: EpgService,
    private pageService: PageService
  ) {
    // do nothing
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.pageService.getSubject(PAGE_KEY.SELECTED_PROGRAM)?.subscribe((program: LocalEPGProgram | undefined) => {
        if (program) {
          this.text = this.formatTimeslot(program.start, program.end)
        } else {
          this.text = ''
        }
      })
    )

    this.subscriptions.add(
      this.pageService.getSubject(PAGE_KEY.SELECTED_CHANNEL)?.subscribe((channel: LocalChannel | undefined) => {
        if (channel) {
          const liveEPG = this.epgService.getChannelLiveEPG(channel.id)
          if (liveEPG && liveEPG.currentProgram) {
            this.text = this.formatTimeslot(liveEPG.currentProgram.start, liveEPG.currentProgram.end)
          } else {
            this.text = ''
          }
        } else {
          this.text = ''
        }
      })
    )
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe()
  }

  formatTimeslot(start: Date, end: Date): string {
    const startStr = moment(start).format('LT')
    const endStr = moment(end).format('LT')
    return `${startStr} - ${endStr}`
  }
}
